import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, ViewChild } from '@angular/core';


export enum KEY_CODE {
    ECHAPE = 27,
    SPACE = 32,
    CRTL = 17
}
@Component({
    selector: 'lean-data-modal',
    templateUrl: './lean-data-modal.component.html',
    styleUrls: ['./lean-data-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LeanDataModal implements OnInit {

    @ViewChild('filter', {static : false}) filter : any;

    @Input() title          : string;
    @Input() filterOpened   : boolean = true;
    @Input() autoLoad       : boolean = false;
    
    @Input() width          : string;
    @Input() minHeight      : string;
    

    @Output() onLoadData: EventEmitter<boolean> = new EventEmitter();
    @Output() onClose   : EventEmitter<boolean> = new EventEmitter();

    public visible = false;
    public visibleAnimate = false;

    constructor() {}

    ngOnInit() {}

    ngAfterViewInit() {
        if (this.filterOpened) this.showFilter(this.filter.nativeElement);
        if (this.autoLoad)     this.onLoadData.emit(null);
    }

    getWidth(){
        if (this.width) return this.width;
        return "600px";
    }
    
    close(){
        this.onClose.emit(null);
    }

    click(e: HTMLDivElement){
        this.loadOrFilter(e);
     }
     
    loadOrFilter(e: HTMLDivElement){
        if (this.filterDisplayed){
          this.onLoadData.emit(null);
          this.hideFilter();
        } else {
          this.showFilter(e);
        }
      }

/*
    hideFilter(e: HTMLDivElement){
        e.style.display = 'none';
        this.filterButton.nativeElement.hidden = false;
    }
    showFilter(e: HTMLDivElement){
        e.style.display = 'block';
        this.filterButton.nativeElement.hidden= true;
    }
*/
//----------------------------------------------
  filterDisplayed   : boolean = false;
  showFilter(e: HTMLDivElement){     
      e.style.display = 'block';
      this.filterDisplayed = true;
  }

  hideFilter(){
    this.filter.nativeElement.style.display = 'none';
      this.filterDisplayed = false;
  }
//----------------------------------------------

  
}
